module.exports = __webpack_public_path__ + "3db953073db8ce2cd24e2c30efc6e3c7.pdf";